import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../iconos/IconosGenerales";
import { fetchCrearSubcategoria } from '../../../peticiones_API/PeticionesSubcategoriasConvocatoria';
import ErrorForm from '../eventos/avisos/Alerta';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidationFormSubcategoria';
import { DatosCorrectos, ServerNoCreoCurso, ServerUrlAFExistente, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";
import useFormPersistence from '../../../hooks/useFormPersistence';

const FormCrearSubcategoria = ({ categorias }) => {

    const handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {

                value.push(options[i].value);
            }
        }
        setFormData(prevFormData => ({
            ...prevFormData,
            categorias: value
        }));
    };

    const initialFormState = {
        nombre: '',
        url: '',
        img: null,
        categorias: [],
        categoria: false
    };

    const [formData, setFormData, clearFormDraft] = useFormPersistence(
        'crear_subcategoria',
        initialFormState
    );

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        img: "Debes adjuntar una imagen"
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        img: null
    });


    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        cursoDuplicado: null,

    });

    const handleSubmit = async (event) => {
        event.preventDefault();

        setEstadosActualizados(false);

        handleSubmitErrors(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);

    };


    useEffect(() => {
        let valorImg = document.getElementById("subcategoria_img").value;
        const f = new Date();
        const dia = ('0' + f.getDate()).slice(-2);
        const mes = ('0' + (f.getMonth() + 1)).slice(-2);
        const año = f.getFullYear();
        const hora = ('0' + f.getHours()).slice(-2);
        const minutos = ('0' + f.getMinutes()).slice(-2);
        const segundos = ('0' + f.getSeconds()).slice(-2);

        if (formData.img == null && valorImg != '') {

            const img = `${dia}${mes}${año}${hora}${minutos}${segundos}_subcategoria_img`;

            setFormData(prevFormData => ({ ...prevFormData, img: img }));
        }



        if (estadosActualizados) {
            console.log("formData", formData);
            console.log("estadoCampoReque", estadoCampoReque);

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    console.log("Simulacion crear subcategoria");

                    try {

                        const response = await fetchCrearSubcategoria(formData);
                        clearFormDraft();
                        console.log("Subcategoria creada:", response);

                    } catch (error) {

                        setFormCompletado(false);

                        if (error?.response?.data?.error === 'categoria repetida error') {

                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, cursoDuplicado: true }));


                        }

                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque]);



    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);

    const handleChange = (event) => {

        const { name, value, type, files, checked } = event.target;

        let newValue;
        if (type === 'file') {
            newValue = files[0];
        } else if (type === 'checkbox') {
            newValue = checked;

            if (name == "categoria" && !checked) {
                setFormData(prevFormData => ({ ...prevFormData, categorias: [] }));
            }
        }
        else {
            newValue = value;
        }


        if (type === 'file' && files[0]) {
            const file = files[0];
            const reader = new FileReader();

            if (name === 'subcategoria_img') {
                reader.onloadend = () => {
                    setPrevisualizacionImg(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }

        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
        setFormData(prevFormData => ({ ...prevFormData, url: "/subcategorias/"+formData.nombre.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-").toLowerCase()}));
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
        console.log("formData", formData);
    };

    const handleDelete = () => {
        setPrevisualizacionImg(null);
        document.getElementById("subcategoria_img").value = "";
        delete formData.img;
        console.log("formData", formData);
    };


    return (
        <>
            <Form >
                <CabeceraForm>
                    <Titulo
                        texto="CREA UNA SUBCATEGORIA"
                        convocatoria="true"
                    />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>

                        <Row md="5">
                            <Col md={3}>
                            </Col>

                            <Col md={3}>
                                <Form.Group >
                                    <TituloPrincipal>Nombre <span>*</span></TituloPrincipal>
                                    <Form.Control type="name" name="nombre" value={formData.nombre || ''} onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                            </Col>

                        </Row>
                        <Row className="mt-4">
                        </Row>
                        <Row md="5">
                            <Col md={3}>
                            </Col>


                            <Col md={4}>
                                <Form.Group>
                                    <InputLabel >
                                        <TituloPrincipal>Categorias </TituloPrincipal>
                                    </InputLabel>
                                    <Select
                                        disabled={!formData.categoria}
                                        multiple
                                        native
                                        value={formData.categorias}
                                        onChange={handleChangeMultiple}
                                        inputProps={{
                                            id: 'select-multiple-native',
                                        }}
                                    >
                                        {categorias.map((categoria) => (
                                            <option key={categoria.Id} value={categoria.Id}>
                                                {categoria.categoria}
                                            </option>
                                        ))}

                                    </Select>
                                </Form.Group>

                            </Col>
                            <Col md={1}>
                                <Row>
                                    <Col>
                                        <Form.Group className="d-flex align-items-center">

                                            <EstiloSwitch
                                                name="categoria"
                                                checked={formData.categoria || false}
                                                onChange={handleChange}
                                                type="switch"
                                                id="categoria"
                                            />
                                            <TituloPrincipal style={{ marginTop: "10px", marginLeft: "10px" }}>Categoria </TituloPrincipal>
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </Col>


                        </Row>

                        <Row md="5">
                            <Col md={4}>
                            </Col>


                            <Col md={4}>
                                <Form.Group className="mb-3 mt-10">
                                    <TituloPrincipal>Adjuntar imagen de la subcategoria </TituloPrincipal>
                                    <Form.Control type="file" id='subcategoria_img' accept=".jpg,.jpeg,.png,.webp" max-file-size="3072"
                                        name="subcategoria_img" onChange={handleChange} />
                                    <ErrorForm mensaje={camposRequeridos.img} estadoAlerta={estadoCampoReque.img} />
                                </Form.Group>
                            </Col>
                            <Col md={1}>
                            </Col>


                        </Row>

                        <Row md="5">
                            <Col md={4}>
                            </Col>


                            <Col md={4}>
                                {previsualizacionImg ? (
                                    <div>
                                        <TituloPrincipal>Vista previa de la imagen:</TituloPrincipal>
                                        <ContenedorEncabezado>
                                            <IconosGenerales
                                                alerta="true"
                                                id="delete"
                                                onClick={handleDelete}
                                            />
                                            <img src={previsualizacionImg} alt="Vista previa" style={{ width: '416px', height: '262px' }} />
                                        </ContenedorEncabezado>
                                    </div>
                                ) : (
                                    <div>
                                        <TituloPrincipal>Vista previa de la imagen:</TituloPrincipal>
                                        <img src={ImagenDefault} alt="Vista previa" style={{ width: '416px', height: '262px' }} />
                                    </div>
                                )}
                            </Col>
                            <Col md={1}>

                            </Col>


                        </Row>

                        <Row md="5">
                            <Col md={4}>
                            </Col>


                            <Col md={4}>
                                <ContenedorBotones>
                                    <Boton
                                        convocatoria="true"
                                        grande="true"
                                        as="button"
                                        primario="true"
                                        type="submit"
                                        onClick={handleSubmit}
                                        form="true"
                                    >
                                        Crear Subcategoria
                                    </Boton>
                                    <Boton
                                        grande="true"
                                        to="/convocatoria/subcategorias"
                                    >
                                        Cancelar
                                    </Boton>
                                </ContenedorBotones>
                            </Col>
                            <Col md={1}>

                            </Col>


                        </Row>


                    </Col>


                   


                </Container>

            </Form>
            <DatosCorrectos envioActivado={formCompletado} />
            <DatosIncorrectos envioActivado={formCompletado} />
            <ServerNoCreoCurso envioActivado={errorEnviarForm.cursoDuplicado} />
            <ServerUrlAFExistente envioActivado={errorEnviarForm.cursoDuplicado} />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 10%;
    margin-bottom: 10px;
`

const TituloPrincipal = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

const EstiloSwitch = styled(Form.Check)`
    
    .form-check-input {
        width: 3.5em !important;
        height: 1.8em !important;
        background-size: 1.5em 1.5em;
        background-color: white;
    }

    .form-check-input:checked {
        background-color: rgb(238, 128, 93) !important;
        border: #dee2e6;
        box-shadow: 0 0 0 .25rem rgba(238, 128, 93, .25);
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }

    .form-check-input:focus {
        border-color: #dee2e6 !important;
        box-shadow: none; 
        --bs-form-switch-bg: url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 8 8"%3e%3ccircle r="3" fill="rgba(0, 0, 0, 0.25)" /%3e%3c/svg%3e') !important;
    }
`

const ContenedorEncabezado = styled.div`
    width: 446px !important;
    height: auto !important;
    border: 1px solid #dee2e6;
`

export default FormCrearSubcategoria;
